import { render, staticRenderFns } from "./OrderDetailItem.vue?vue&type=template&id=7f26fd80&scoped=true"
import script from "./OrderDetailItem.vue?vue&type=script&lang=js"
export * from "./OrderDetailItem.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailItem.vue?vue&type=style&index=0&id=7f26fd80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f26fd80",
  null
  
)

export default component.exports